import { useEffect, useReducer } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Get, Post } from "api.js";
import { useForm } from "react-hook-form";
import { humanizeSize } from "common.js"

import { ConnectionForm, connectionInitialState, connectionReducer } from "components/DatabaseConnection";

import Loading from "components/Loading";
const {
  Alert,
  Button,
  Card,
  Form,
  Spinner,
  Table,
  Row,
  Col,
} = require("react-bootstrap");

const initialState = {
  ...connectionInitialState,
  loading: true,
  database: {},
  backup: {},
  destinationDatabase: {},
  enteringDestination: true,
  submitting: false,
};

function reducer(state, action) {
  const connectionState = connectionReducer(state, action);
  if (connectionState != null) {
    return connectionState;
  }
  switch (action.type) {
    case 'LOAD':
      return { ...state, loading: true };
    case 'LOADED':
      return {
        ...state,
        database: action.database,
        backup: action.backup,
        loading: false,
      };
    case 'ENTERED_DESTINATION':
      return {
        ...state,
        enteringDestination: false,
        destinationDatabase: action.destination,
      }
    case 'SUBMITTING':
      return {
        ...state,
        submitting: true,
      };
    case 'SUBMITTED':
      return {
        loading: false,
        backup: state.backup,
        database: state.database,
      }
    default:
      throw new Error('unknown action ' + action);
  }
}

function Confirmation({ state }) {
  const auth = useAuth0();
  let history = useHistory();
  const onSubmit = async () => {
    const restore = await Post(auth, '/v1/database/' + state.database.id + '/restore', state.destinationDatabase);
    console.log("restore operation", restore);
    history.push('/database/' + state.database.id + '/restore/' + restore.restoreId);
  }
  return <Card.Body>
    <Card.Title>Confirmation</Card.Title>
    <div>
      Please confirm the details of the backup we will restore.
      <Table>
        <h3 style={{ marginTop: "10px" }}>General Information</h3>
        <tr>
          <th width="30%">Created At</th>
          <th width="70%">{state.backup.created}</th>
        </tr>
        <tr>
          <th>Size</th>
          <th>{humanizeSize(state.backup.backupSize)}</th>
        </tr>
        <tr>
        </tr>
        <h3 style={{ marginTop: "10px" }}>Destination Database</h3>
        <tr>
          <th>MySQL Host</th>
          <th>{state.destinationDatabase.target_database.hostport}</th>
        </tr>
        <tr>
          <th>MySQL Username</th>
          <th>{state.destinationDatabase.target_database.username}</th>
        </tr>
        <tr>
          <th>MySQL Password</th>
          <th>***</th>
        </tr>
      </Table>
      <Button onClick={onSubmit}>Confirm</Button>
      <Button variant="secondary" onClick={() => history.goBack()}>Back</Button>
    </div>
  </Card.Body >;
}

function DestinationDatabaseEntry({ state, dispatch }) {
  const form = useForm({ mode: 'onChange' });
  const { handleSubmit, trigger } = form;
  const { backup_id: backupId } = useParams();

  const onSubmit = (formData) => {
    // we can only submit if validation has completed successfully.
    if (!state.connection.valid) {
      trigger();
      return;
    }
    console.log('form data', formData);
    let destinationData = {
      "cursor": {
        "dump_id": backupId,
      },
      "target_database": {
        "hostport": formData.hostport,
        "username": formData.username,
        "password": formData.password,
      },
    };
    dispatch({ type: 'ENTERED_DESTINATION', destination: destinationData });
  };

  let submitButton = <Button
    disabled={false}
    style={{ marginRight: "10px" }}
    type="submit"
    variant="primary">
    Restore
  </Button>;

  return <Card.Body>
    <Form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
      <Card.Title>Destination Database</Card.Title>

      <Row>
        <Col className="control-label" sm="3">
        </Col>
        <Col>
          <Alert variant="warning">
            Note that restoring a backup will overwrite existing data on the destination database.
            This may cause data loss on your destination database. Contact support on the bottom
            right for more information.
          </Alert>
        </Col>
      </Row>
      <ConnectionForm form={form} dispatch={dispatch} state={state} />
      {submitButton}
    </Form>
  </Card.Body>
}

function DatabaseCreateRestore() {
  const { database_id: databaseId, backup_id: backupId } = useParams();

  const auth = useAuth0();
  const [state, dispatch] = useReducer(reducer, initialState);
  console.log('state', state);

  const loadDatabase = (async () => {
    dispatch({ type: 'LOAD' });
    var database = await Get(auth, '/v1/database/' + databaseId)
    console.log('Database, ', database);
    database.reload = loadDatabase;

    var backup = null;
    for (let b in database.backup) {
      if (backupId == database.backup[b].id) {
        backup = database.backup[b];
        break;
      }
    }
    dispatch({ type: 'LOADED', database: database, backup: backup });
  });

  useEffect(() => {
    loadDatabase();
  }, [databaseId]);

  if (state.loading) {
    return (<Loading />)
  }

  if (state.enteringDestination) {
    return <DestinationDatabaseEntry state={state} dispatch={dispatch} />;
  }
  return <Confirmation state={state} dispatch={dispatch} />;
}

function DatabaseCreateRestoreLayout(props) {
  return <>
    <h1 style={{ marginTop: "5px" }}>Restore Backup</h1>
    <Card><DatabaseCreateRestore {...props} /></Card>
  </>
}

export default DatabaseCreateRestoreLayout;